import { fg } from '@confluence/feature-gating';

export enum ButtonState {
	LOADING = 'LOADING',
	RULE_DELETED = 'RULE_DELETED',
	RULE_DISABLED = 'RULE_DISABLED',
	RULE_MOVED = 'RULE_MOVED',
	RULE_NOT_RUNNABLE = 'RULE_NOT_RUNNABLE',
	INVALID_CONTENT_TYPE = 'INVALID_CONTENT_TYPE',
	NOT_AVAILABLE = 'NOT_AVAILABLE',
	VIEW_RULE_NOT_CONFIGURED = 'VIEW_RULE_NOT_CONFIGURED',
	MISSING_PERMISSIONS = 'MISSING_PERMISSIONS',
	AI_DISABLED = 'AI_DISABLED',
	EDIT_RULE_NOT_CONFIGURED = 'EDIT_RULE_NOT_CONFIGURED',
	PREDEFINED_TEMPLATE_NOT_CONFIGURED = 'PREDEFINED_TEMPLATE_NOT_CONFIGURED',
	EDIT_RULE_CONFIGURED = 'EDIT_RULE_CONFIGURED', // This is the state for a configured but non-runnable button in edit mode
	RULE_CONFIGURED = 'RULE_CONFIGURED', // This is the state for a configured and runnable button in view mode
}

export const disabledStates: ButtonState[] = [
	ButtonState.LOADING,
	ButtonState.RULE_DELETED,
	ButtonState.RULE_DISABLED,
	ButtonState.RULE_MOVED,
	ButtonState.RULE_NOT_RUNNABLE,
	ButtonState.INVALID_CONTENT_TYPE,
	ButtonState.NOT_AVAILABLE,
	ButtonState.VIEW_RULE_NOT_CONFIGURED,
	ButtonState.MISSING_PERMISSIONS,
	ButtonState.AI_DISABLED,
];

export const configurationStates: ButtonState[] = [
	ButtonState.EDIT_RULE_NOT_CONFIGURED,
	ButtonState.RULE_CONFIGURED,
];

export const editModeUnconfiguredStates: ButtonState[] = [
	ButtonState.EDIT_RULE_NOT_CONFIGURED,
	ButtonState.PREDEFINED_TEMPLATE_NOT_CONFIGURED,
];

export const previewStates: ButtonState[] = [
	ButtonState.LOADING,
	ButtonState.RULE_CONFIGURED,
	ButtonState.VIEW_RULE_NOT_CONFIGURED,
];

// Conditionally add EDIT_RULE_CONFIGURED to disabledStates if the feature is enabled
// TODO: Remove extra condition once the feature is enabled by default and also add EDIT_RULE_CONFIGURED into disabledStates
export const isDisabledState = (buttonState: ButtonState) =>
	disabledStates.includes(buttonState) ||
	(buttonState === ButtonState.EDIT_RULE_CONFIGURED && fg('a4c-enable-live-doc-smart-button'));

export const isPreviewState = (buttonState: ButtonState) => previewStates.includes(buttonState);
export const isEditModeUnconfiguredState = (buttonState: ButtonState) =>
	editModeUnconfiguredStates.includes(buttonState);
